export default [
  {
    path: "/manage",
    name: "",
    component: (resolve) => require(["@/views/home"], resolve),
    children: [
      {
        path: "statisticaltable",
        name: "采编统计",
        meta: {
          title: "采编统计",
        },
        component: (resolve) =>
          require(["@/views/manage/statisticaltable/index"], resolve),
      },
      {
        path: "/manage/corporateManagement",
        name: "集团管理 ",
        meta: {
          title: "集团管理",
        },
        component: (resolve) =>
          require(["@/views/manage/corporateManagement/index"], resolve),
      },
      {
        path: "/manage/journalReview",
        name: "期刊审核 ",
        meta: {
          title: "期刊审核",
        },
        component: (resolve) =>
          require(["@/views/manage/journalReview/index"], resolve),
      },
      {
        path: "/manage/periodicalManagement",
        name: "期刊管理 ",
        meta: {
          title: "期刊管理",
        },
        component: (resolve) =>
          require(["@/views/manage/periodicalManagement/index"], resolve),
      },
      {
        path: "/manage/subjectManage",
        name: "学科管理",
        meta: {
          title: "学科管理",
        },
        component: (resolve) =>
          require(["@/views/manage/subjectManage/index"], resolve),
      },
      {
        path: "/manage/gradeManage",
        name: "单位级别管理",
        meta: {
          title: "单位级别管理",
        },
        component: (resolve) =>
          require(["@/views/manage/gradeManage/index"], resolve),
      },
      {
        path: "/manage/payeeMerchant",
        name: "收款商户",
        meta: {
          title: "收款商户",
        },
        component: (resolve) =>
          require(["@/views/manage/payeeMerchant/index"], resolve),
      },
      {
        path: "/manage/JournalCount",
        name: "期刊统计",
        meta: {
          title: "期刊统计",
        },
        component: (resolve) =>
          require(["@/views/manage/JournalCount/index"], resolve),
      },
      {
        path: "/manage/userFeel",
        name: "用户反馈",
        meta: {
          title: "用户反馈",
        },
        component: (resolve) =>
          require(["@/views/manage/userFeel/index"], resolve),
      },
      {
        path: "/manage/otherSettings",
        name: "其他设置",
        meta: {
          title: "其他设置",
        },
        component: (resolve) =>
          require(["@/views/manage/otherSettings"], resolve),
      },
      {
        path: "/manage/webLoginRecord",
        name: "用户日志",
        meta: {
          title: "用户日志",
        },
        component: (resolve) =>
          require(["@/views/manage/webLoginRecord"], resolve),
      },
      {
        path: "/manage/journalReview/audit",
        name: "查看资料",
        meta: {
          title: "查看资料",
        },
        component: (resolve) =>
          require(["@/views/manage/journalReview/basicInfo/audit"], resolve),
      },
      {
        path: "/manage/messageNotification",
        name: "消息通知",
        meta: {
          title: "消息通知",
        },
        component: (resolve) =>
          require(["@/views/manage/messageNotification"], resolve),
      },
      {
        path: "/manage/personalData",
        name: "个人信息",
        meta: {
          title: "个人信息",
        },
        component: (resolve) =>
          require(["@/views/manage/personalData"], resolve),
      },
      {
        path: "welcome",
        name: " 首页 ",
        meta: {
          title: "首页",
        },
        component: (resolve) => require(["@/views/manage/welcome"], resolve),
      },
      {
        path: "/manage/journalUser",
        name: " 用户日志 ",
        meta: {
          title: "用户日志",
        },
        component: (resolve) =>
          require(["@/views/manage/journalUser/index"], resolve),
      },
      {
        path: "/manage/journalReview/authorLoginDetail",
        name: " 期刊审核 ",
        meta: {
          title: "期刊审核",
        },
        component: (resolve) =>
          require(["@/views/manage/journalReview/authorLogin/detail"], resolve),
      },
    ],
  }, //第二大类共用部分
  {
    path: "/loginAdmin",
    name: "用户反馈",
    meta: {
      title: "用户反馈",
    },
    component: (resolve) => require(["@/views/manage/loginAdmin"], resolve),
  },
];



// WEBPACK FOOTER //
// ./src/router/manage_routers.js